module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "game-content-members-edit"
    }
  }, [_c('h2', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Manage Members")]), _vm._v(" "), _c('span', {
    staticClass: "enter-edit-mode"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exitEditMode($event)
      }
    }
  }, [_vm._v("Exit Manage Mode")])])]), _vm._v(" "), _vm._l((_vm.formData), function(member) {
    return (member.status === 'Current') ? _c('editable-member', {
      attrs: {
        "member": member,
        "positions": _vm.positions,
        "my-id": _vm.myId,
        "game-id": _vm.gameId
      }
    }) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-541892b3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/SubPages/GameMembersEdit.vue
// module id = 872
// module chunks = 2